import { stringifyForAttribute } from '@kissui/helpers/src/utils'

export const renderLogos = (props, component) => {
    const {
        fair_trade,
        alt_fair_trade,
        is_organic,
        alt_organic,
        only_vertuo_next,
        alt_vertuo_next,
        is_rainforest,
        alt_rainforest,
        is_sustainable,
        alt_sustainable,
        is_q_certified_arabica,
        alt_q_certification_arabica,
        logos
    } = props

    if (
        !fair_trade &&
        !is_organic &&
        !only_vertuo_next &&
        !is_rainforest &&
        !is_sustainable &&
        !is_q_certified_arabica &&
        (logos == null || logos.length < 1)
    ) {
        return ''
    }

    component.classList.add('has-logos')

    const data = {
        fair_trade,
        alt_fair_trade,
        is_organic,
        alt_organic,
        only_vertuo_next,
        alt_vertuo_next,
        is_rainforest,
        alt_rainforest,
        is_sustainable,
        alt_sustainable,
        is_q_certified_arabica,
        alt_q_certification_arabica,
        logos
    }
    return `<nb-card-logos data='${stringifyForAttribute(data)}'></nb-card-logos>`
}
